export default {
  ERROR: 'positionTrackerError',
  POSITION_TRACKING_STOPPED: 'positionTrackingStopped'
};
